<template>
    <div class="loadmore text-center">
        <a href="javascript:void(0);" class="posr" @click="$emit('loadMore')">
            {{ text }}
            <div class="spinner-wrap">
                <div class="spinner">
                    <i v-for="(index) in 12" v-bind:key="index"></i>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    import $ from 'jquery';
    export default {
        props: {
            triggerOnScroll: {
                type: Boolean,
                default() {
                    return true;
                },
            },
        },
        data() {
            return {
                text: '載入更多'
            }
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
            this.handleScroll();
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            handleScroll() {
                if (this.isScrolledIntoView() && this.triggerOnScroll) {
                    this.$emit('loadMore');
                }
            },
            isScrolledIntoView() {
                var docViewTop = $(window).scrollTop();
                var docViewBottom = docViewTop + $(window).height();

                var elemTop = $(this.$el).offset().top;
                var elemBottom = elemTop + $(this.$el).height();

                return ((elemBottom <= docViewBottom) && (elemTop >= docViewTop));
            }
        },
    }
</script>